export const useFakeProgress = (loading: Ref<boolean>) => {
  const progress = ref(0);

  const { pause, resume } = useIntervalFn(
    () => {
      progress.value += (90 - progress.value) * 0.1;
    },
    200,
    { immediate: false },
  );

  const { start: scheduleReset } = useTimeoutFn(
    () => {
      progress.value = 0;
    },
    700,
    { immediate: false },
  );

  watch(loading, (isLoading) => {
    if (isLoading) {
      progress.value = 0;
      resume();
    } else {
      pause();
      progress.value = 100;
      scheduleReset();
    }
  });

  return { progress: readonly(progress) };
};
